/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import {getJwt, Loader, ResponseData, setJwt, showDialog} from '@dvrd/dvr-controls';

import './util/startup';
import React, {useContext, useEffect, useState} from 'react';
import {Outlet, useNavigate} from 'react-router';
import {AppContext} from './components/context/appContext';
import Header from './components/header/header';
import PopupController from './components/misc/popupController';
import User from './models/userModel';
import Vehicle from './models/vehicleModel';
import {AUTHENTICATED_URL, LOGIN_PATH, VEHICLE_STORAGE_KEY} from './util/constants';
import {loadFromStorage} from './util/storageUtil';
import {createErrorMessage} from './util/utils';

function getActiveVehicle(vehicles: Array<Vehicle>): Vehicle | null {
    const activeVehicleID = loadFromStorage(VEHICLE_STORAGE_KEY);
    if (!activeVehicleID) return null;
    return vehicles.find((vehicle: Vehicle) => vehicle.id === activeVehicleID) ?? null;
}

export default function App() {
    const context = useContext(AppContext);
    const [validating, setValidating] = useState(true);
    const navigate = useNavigate();

    function loadVehicles() {
        if (!context.userContext.user) return;
        Vehicle.getAll((vehicles: Array<Vehicle>, success: boolean, data: ResponseData) => {
            if (!success) return showDialog(
                createErrorMessage(data.message ?? 'Het laden van de voertuigen is niet gelukt.'), 'Laden mislukt');
            const activeVehicle = getActiveVehicle(vehicles);
            context.onChangeContext({vehicles, vehicle: activeVehicle});
        });
    }

    function validateUser() {
        if (getJwt()) {
            User.get((user: User | null, success: boolean) => {
                if (success) {
                    context.onChangeContext({user}, startApplication);
                } else {
                    setJwt(null);
                    startApplication();
                }
            });
        } else setValidating(false);
    }

    function startApplication() {
        setValidating(false);
        if (window.location.pathname.includes(LOGIN_PATH))
            window.setTimeout(() => {
                navigate(AUTHENTICATED_URL);
            });
    }

    useEffect(() => {
        validateUser();
    }, []);

    useEffect(() => {
        loadVehicles();
    }, [context.userContext.user]);

    if (validating) return <Loader label='Applicatie laden...' active/>;
    return (
        <>
            <Header/>
            <div className='page'>
                <Outlet/>
            </div>
            <PopupController/>
        </>
    );
}